import { useLocation, useNavigate } from 'react-router-dom';

export const useClearQueryString = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const clearQueryString = () => {
    const { pathname, search } = location;
    if (search) navigate(pathname, { replace: true });
  };
  return { clearQueryString };
};
